import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { settlementNoteIdZodSchema } from "@@/shared/reports/settlement-notes/settlement-note-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

const createSettlementNotePdfsCommandZodObject = z.object({
    _id: z.string(),
    _createdAt: isoAndUnixZodSchema,
    _type: z.literal("CREATE_SETTLEMENT_NOTE_PDFS_COMMAND"),
    requestedBy: userIdZodSchema,
    parentJobId: z.union([z.string(), z.number()]).optional(),
    settlementNoteId: settlementNoteIdZodSchema,
});
type CreateSettlementNotePdfsCommand = z.infer<
    typeof createSettlementNotePdfsCommandZodObject
>;

type FactoryParams = Except<
    CreateSettlementNotePdfsCommand,
    "_id" | "_type" | "_createdAt"
>;
const createSettlementNotePdfsCommandFactory = (params: FactoryParams) => {
    const CreateSettlementNotePdfsCommand: CreateSettlementNotePdfsCommand = {
        ...params,
        _id: generateId({ prefix: "create_settlement_note_PDFS_command__" }),
        _type: "CREATE_SETTLEMENT_NOTE_PDFS_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return CreateSettlementNotePdfsCommand;
};

export {
    createSettlementNotePdfsCommandFactory,
    createSettlementNotePdfsCommandZodObject,
};
export type { CreateSettlementNotePdfsCommand };
